/*
 * Copyright 2015 Daishinsha Inc.
 *
 * This file is part of Vivliostyle UI.
 *
 * Vivliostyle UI is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * Vivliostyle UI is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with Vivliostyle UI.  If not, see <http://www.gnu.org/licenses/>.
 */

import ko from "knockout";

import ViewerApp from "./viewmodels/viewer-app";

import "./bindings/menuButton";
import "./bindings/swipePages";
import "./bindings/textSelection";
import "./bindings/clickOutside";
import "./bindings/i18n";

export default {
  start(): void {
    function startViewer(): void {
      ko.applyBindings(new ViewerApp());
    }

    if (window["__loaded"]) startViewer();
    else window.onload = startViewer;
  },
};
